import { useState, useEffect } from 'react';
import { enabledFeatureFlagsApi } from '@/services/api';

export const useFeatureFlag = (flagName: string) => {
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkFlag = async () => {
      try {
        const res = await enabledFeatureFlagsApi.getDetail(flagName);
        setEnabled(res.enabled);
      } catch {
        setEnabled(false);
      } finally {
        setLoading(false);
      }
    };
    checkFlag();
  }, [flagName]);

  return { enabled, loading };
};
